import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { Building2 } from 'lucide-react';
import employeeApi from '../../lib/employeeApi';
import EmployeeLayout from '../../components/EmployeeLayout';

export default function ClientsPage() {
  const [clients, setClients] = useState([]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await employeeApi.get('/api/clients');
      setClients(res.data);
    } catch (error) {
      toast.error('Failed to load');
    }
  };

  return (
    <EmployeeLayout>
      <div className="p-8">
        <h1 className="text-2xl font-bold text-charcoal-900 mb-6">Clients</h1>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {clients.map((client) => (
            <Link key={client._id} to={`/employee/clients/${client._id}`} className="bg-white rounded-xl border border-charcoal-200 p-6 hover:border-pink-500 hover:shadow-lg transition-all">
              <h3 className="text-lg font-semibold text-charcoal-900 mb-2">{client.name}</h3>
              <p className="text-sm text-charcoal-600 mb-3">{client.industry}</p>
              <div className="flex flex-wrap gap-2">
                {client.departments?.map((d, i) => <span key={i} className="px-2 py-1 bg-charcoal-100 text-charcoal-700 rounded-xl text-xs">{d}</span>)}
              </div>
            </Link>
          ))}
        </div>
      </div>
    </EmployeeLayout>
  );
}